<template>
	<div class="section-carteira">
		<!-- Mobile -->
		<div v-if="isMobile" class="mobile-pseudo-table">
			<div class="caption">Rentabilidade da carteira</div>
			<div v-for="(item, index) in table.items" class="tr" :key="index">
				<div v-for="field in table.fields"  class="v-col" :key="field.key">
					<div class="th">{{field.label}}</div>
					<div class="td" :class="item[field.key] < 0 ? 'negative' : 'positive'">
						{{formatFunction(item[field.key], field.formatter)}}
					</div>
				</div>
			</div>
		</div>
		<!-- Desktop -->
		<b-table v-else :items="table.items" :fields="table.fields">
			<template #table-caption>Rentabilidade da carteira</template>
			<template v-slot:cell(valorAplicado)="data">
				<span :class="data.unformatted < 0 ? 'negative' : 'positive'">{{data.value}}</span>
			</template>
			<template v-slot:cell(rentabilidadeMes)="data">
				<span :class="data.unformatted < 0 ? 'negative' : 'positive'">{{data.value}}</span>
			</template>
			<template v-slot:cell(rentabilidadeAno)="data">
				<span :class="data.unformatted < 0 ? 'negative' : 'positive'">{{data.value}}</span>
			</template>
			<template v-slot:cell(rentabilidade12Meses)="data">
				<span :class="data.unformatted < 0 ? 'negative' : 'positive'">{{data.value}}</span>
			</template>
			<template v-slot:cell(rentabilidade24Meses)="data">
				<span :class="data.unformatted < 0 ? 'negative' : 'positive'">{{data.value}}</span>
			</template>
			<template v-slot:cell(rentabilidadeDesdeInicio)="data">
				<span :class="data.unformatted < 0 ? 'negative' : 'positive'">{{data.value}}</span>
			</template>
		</b-table>
	</div>
</template>

<script>
import SimuladorService from "@/app/services/Simulador/simulador.service";
import UtilsService from '../../services/utils.service';
import moment from 'moment';

export default {
	data() {
		return {
			table: {
				fields: [
					{ key: 'valorAplicado', label: 'Saldo Atual', formatter: 'formatarDinheiro', class: 'text-center' },
					{ key: 'rentabilidadeMes', label: 'Rentabilidade no mês', formatter: 'formatarPorcentagem', class: 'text-center' },
					{ key: 'rentabilidadeAno', label: 'Rentabilidade no  ano', formatter: 'formatarPorcentagem', class: 'text-center' },
					{ key: 'rentabilidade12Meses', label: 'Rentabilidade em 12 meses', formatter: 'formatarPorcentagem', class: 'text-center' },
					{ key: 'rentabilidade24Meses', label: 'Rentabilidade em 24 meses', formatter: 'formatarPorcentagem', class: 'text-center' },
					{ key: 'rentabilidadeDesdeInicio', label: 'Rentabilidade desde o início', formatter: 'formatarPorcentagem', class: 'text-center' },
					// { key: 'sharp', label: 'Sharpe' },
					// { key: 'volatilidade', label: 'Volatilidade' },
				],
				items: []
			}
		};
	},
	props: {
		forcarRenderizacao: {
			default: 0,
			type: Number
		}
	},
	beforeMount() {
		this.carregarDados();
	},
	methods: {
		carregarDados() {
			SimuladorService.obterRentabilidadeTabelaCarteira({
				token: this.$route.query.token,
				dataReferencia: this.dataReferencia
			}).then((retorno) => {
				if (retorno.sucesso) {
					this.table.items = [retorno.rentabilidades[0]];
				}
			})
		},
		formatarDinheiro(numero) {
			return "R$ " + UtilsService.formatNumber(numero);
		},
		formatarPorcentagem(numero) {
			return UtilsService.formatNumber(numero) + "%";
		},
		formatarNumero(numero) {
			return UtilsService.formatNumber(numero);
		},		
		iconeStonksParaValor(valor) {
			return valor > 0
				? require("../../assets/img/green_arrow.png") // Stonks
				: require("../../assets/img/red_arrow.png");  // Not Stonks
		},
		onClickCard(periodo) {
			this.$emit("clickedCard", periodo);
		},
		formatFunction(value, formatter) {
			let func = this[formatter];
			if (typeof(func) == 'function') {
				return func(value)
			}
			return value;
		}
	},
	computed: {
		dataReferencia() {
			let datas = this.$store.getters.getDatasPeriodo;
			return moment(datas.maiorData ?? new Date()).format("YYYY-MM-DD");
		},
		isMobile() {
            return this.$mq != 'desktop';
        }
	},
	watch: {
		forcarRenderizacao: {
			handler(n, o) {
				this.carregarDados();
			},
			deep: true
		}
	}
};
</script>

<style lang="scss">

</style>